<template>
  <div>
    <div class="archives">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="p-3">
            <h2 class="main-title">
              On Balance: Daily Notes for January 11, 2022
            </h2>
            <p class="text-muted m-0">Posted on January 11, 2022</p>

            <h5 class="sub-title-page">Stock Recommendation</h5>
            <table class="table table-bordered stock-reco-card w-100">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="2" class="text-center">
                    Monde Nissin Corporation [ PSE : MONDE ]
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    BUY ON BREAKOUT
                  </td>
                  <td class="text-center">
                    ST-Target Price: Php 38-39.00
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="p-3">
            <h5 class="sub-title-page">Our View</h5>
            <p class="text-muted">
              Trade cautiously. Despite the growing Covid-19 cases, the local
              bourse stays above the 7,000 psychological level. It shows that
              investors are hopeful that the government will not raise the
              current alert level restrictions to more strict quarantine
              measures.
            </p>
            <p class="text-muted">
              However, the PSEi still struggles to get past the 7,300 resistance
              particularly that we see no major catalysts now in the market.
              Investors may wait for the Covid-19 cases in the Philippines to
              reach its peak and be followed by the negative growth rates in the
              coming days. In this way, investors who stayed on the sidelines
              are expected to return to the market.
            </p>

            <a href="#">Read full research</a>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="archives">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="p-3">
            <h2 class="main-title">
              On Balance: Daily Notes for January 11, 2022
            </h2>
            <p class="text-muted m-0">Posted on January 11, 2022</p>

            <h5 class="sub-title-page">Stock Recommendation</h5>
            <table class="table table-bordered stock-reco-card w-100">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="2" class="text-center">
                    Nickel Asia Corporation [ PSE : NIKL ]
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    BUY ON BREAKOUT
                  </td>
                  <td class="text-center">
                    ST-Target Price: Php 38-39.00
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="p-3">
            <h5 class="sub-title-page">Our View</h5>
            <p class="text-muted">
              Trade cautiously. Despite the growing Covid-19 cases, the local
              bourse stays above the 7,000 psychological level. It shows that
              investors are hopeful that the government will not raise the
              current alert level restrictions to more strict quarantine
              measures.
            </p>
            <p class="text-muted">
              However, the PSEi still struggles to get past the 7,300 resistance
              particularly that we see no major catalysts now in the market.
              Investors may wait for the Covid-19 cases in the Philippines to
              reach its peak and be followed by the negative growth rates in the
              coming days. In this way, investors who stayed on the sidelines
              are expected to return to the market.
            </p>

            <a href="#">Read full research</a>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="archives">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="p-3">
            <h2 class="main-title">
              On Balance: Daily Notes for January 11, 2022
            </h2>
            <p class="text-muted m-0">Posted on January 11, 2022</p>

            <h5 class="sub-title-page">Stock Recommendation</h5>
            <table class="table table-bordered stock-reco-card w-100">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="2" class="text-center">
                    Ayala Land, Inc. [ PSE : ALI ]
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    BUY ON BREAKOUT
                  </td>
                  <td class="text-center">
                    ST-Target Price: Php 38-39.00
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="p-3">
            <h5 class="sub-title-page">Our View</h5>
            <p class="text-muted">
              Trade cautiously. Despite the growing Covid-19 cases, the local
              bourse stays above the 7,000 psychological level. It shows that
              investors are hopeful that the government will not raise the
              current alert level restrictions to more strict quarantine
              measures.
            </p>
            <p class="text-muted">
              However, the PSEi still struggles to get past the 7,300 resistance
              particularly that we see no major catalysts now in the market.
              Investors may wait for the Covid-19 cases in the Philippines to
              reach its peak and be followed by the negative growth rates in the
              coming days. In this way, investors who stayed on the sidelines
              are expected to return to the market.
            </p>

            <a href="#">Read full research</a>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="archives">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6">
          <div class="p-3">
            <h2 class="main-title">
              On Balance: Daily Notes for January 11, 2022
            </h2>
            <p class="text-muted m-0">Posted on January 11, 2022</p>

            <h5 class="sub-title-page">Stock Recommendation</h5>
            <table class="table table-bordered stock-reco-card w-100">
              <thead class="stock-reco-header">
                <tr>
                  <th colspan="2" class="text-center">
                    Ayala Land, Inc. [ PSE : ALI ]
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">
                    BUY ON BREAKOUT
                  </td>
                  <td class="text-center">
                    ST-Target Price: Php 38-39.00
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="p-3">
            <h5 class="sub-title-page">Our View</h5>
            <p class="text-muted">
              Trade cautiously. Despite the growing Covid-19 cases, the local
              bourse stays above the 7,000 psychological level. It shows that
              investors are hopeful that the government will not raise the
              current alert level restrictions to more strict quarantine
              measures.
            </p>
            <p class="text-muted">
              However, the PSEi still struggles to get past the 7,300 resistance
              particularly that we see no major catalysts now in the market.
              Investors may wait for the Covid-19 cases in the Philippines to
              reach its peak and be followed by the negative growth rates in the
              coming days. In this way, investors who stayed on the sidelines
              are expected to return to the market.
            </p>

            <a href="#">Read full research</a>
          </div>
        </div>
      </div>

  <Pagination/>
  

    </div>
  </div>
</template>

<script>
import Pagination from "../../ResearchPages/Pagination";
export default {
  components: {
    Pagination,
  }
};
</script>
<style>
</style>